exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#render-container .retailersmodal-box .retailer-list a:hover{border-bottom:none}.retailersmodal-box .dropdown-box label:first-child{display:none}.retailersmodal-box .retailer-instruction{font-size:22px;font-family:CorporateACondensedRegular,Georgia,serif;margin-bottom:10px}.retailersmodal-box .retailer-list{display:none;margin:0;padding:0;max-height:300px;overflow:auto}.retailersmodal-box .retailer-list li{background-color:#ccc;padding:10px;line-height:20px}.retailersmodal-box .retailer-list li:nth-child(2n){background-color:#dfdfdf}.retailersmodal-box .retailer-list li a{color:#000!important}.retailersmodal-box .retailer-list li:hover{background-color:#4e9de1}.retailersmodal-box .retailer-list li:hover a{color:#fff!important}@media (min-width:750px){.retailersmodal-box .retailer-list{max-height:500px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./js-src/markdown-editor/modules/retailersmodal/retailersmodal.styl
// module id = 95
// module chunks = 0 1